import { useState, useEffect } from "react";
import type { BoardsConfigPanelValues } from "../configure-panel";
import { getBoardsConfigurePanelValues } from "../configure-panel";
import { BOARDS_CONFIGURE_PANEL_UPDATE_EVENT, BOARDS_CONFIGURE_PANEL_KEY } from "../utils";

/**
 * Hook to reactively track the boards configure panel values.
 * Listens for both cross-tab (storage) and same-window (custom event) updates,
 * merging saved values with defaults so missing keys always have a value.
 */
export function useBoardsConfig(): BoardsConfigPanelValues {
   const [config, setConfig] = useState(getBoardsConfigurePanelValues);

   // Listen for storage events and custom events to update the configuration
   useEffect(() => {
      const handleStorageChange = (e: StorageEvent) => {
         if (e.key === BOARDS_CONFIGURE_PANEL_KEY) {
            setConfig(getBoardsConfigurePanelValues());
         }
      };

      const handleCustomStorageChange = (e: CustomEvent) => {
         if (e.detail.key === BOARDS_CONFIGURE_PANEL_KEY) {
            setConfig(getBoardsConfigurePanelValues());
         }
      };

      window.addEventListener("storage", handleStorageChange);
      window.addEventListener(
         BOARDS_CONFIGURE_PANEL_UPDATE_EVENT,
         handleCustomStorageChange as EventListener,
      );

      return () => {
         window.removeEventListener("storage", handleStorageChange);
         window.removeEventListener(
            BOARDS_CONFIGURE_PANEL_UPDATE_EVENT,
            handleCustomStorageChange as EventListener,
         );
      };
   }, []);

   return config;
}
